import queryString from 'query-string';
import { getFormValues } from 'redux-form';
import { message } from 'antd';

import {
  CANCELLATION_NOTES_FORM_NAME,
  NOTE_DISPLAY_FORM_NAME,
  PLAN_TABS as TABS,
} from './constants';

const { success } = message;

const MODULE_NAME = 'ADMIN';

export const GET_PLANS_SUCCESS = `${MODULE_NAME}/GET_PLANS/SUCCESS`;
export const GET_PLANS_FAIL = `${MODULE_NAME}/GET_PLANS/FAIL`;
export const getPlans = () => async (dispatch, getState) => {
  const {
    admin: {
      plansFilter,
      plansPagination: { page, perPage },
    },
  } = getState();

  try {
    const query = queryString.stringify({ page, perPage, ...plansFilter });
    const plans = await fetch(`/admin/api/plans?${query}`);

    return dispatch({
      type: GET_PLANS_SUCCESS,
      payload: plans,
    });
  } catch (e) {
    return dispatch({ type: GET_PLANS_FAIL, payload: e });
  }
};

export const COUNT_PLANS_SUCCESS = `${MODULE_NAME}/COUNT_PLANS/SUCCESS`;
export const COUNT_PLANS_FAIL = `${MODULE_NAME}/COUNT_PLANS/FAIL`;
export const countPlans = () => async (dispatch, getState) => {
  const {
    admin: { plansFilter },
  } = getState();

  const query = queryString.stringify(plansFilter);

  try {
    const { total } = await fetch(`/admin/api/plans/total?${query}`);

    return dispatch({ type: COUNT_PLANS_SUCCESS, payload: total });
  } catch (e) {
    return dispatch({ type: COUNT_PLANS_FAIL, payload: e });
  }
};

export const fetchPlans = () => dispatch =>
  Promise.all([dispatch(getPlans()), dispatch(countPlans())]);

export const CHANGE_PLANS_PAGE = `${MODULE_NAME}/CHANGE_PLANS_PAGE`;
export const changePlansPage = page => dispatch =>
  dispatch({ type: CHANGE_PLANS_PAGE, payload: page });

export const UPDATE_PLANS_FILTERS = `${MODULE_NAME}/UPDATE_PLANS_FILTERS`;
export const updateFilter = (name, value) => async dispatch =>
  dispatch({ type: UPDATE_PLANS_FILTERS, payload: { field: name, value } });

export const GET_PLAN_DETAILS_SUCCESS = `${MODULE_NAME}/GET_PLAN_DETAILS/SUCCESS`;
export const GET_PLAN_DETAILS_FAIL = `${MODULE_NAME}/GET_PLAN_DETAILS/FAIL`;
export const getPlanDetails = id => async dispatch => {
  try {
    const plan = await fetch(`/admin/api/plans/${id}`);

    return dispatch({
      type: GET_PLAN_DETAILS_SUCCESS,
      payload: plan,
    });
  } catch (e) {
    return dispatch({ type: GET_PLAN_DETAILS_FAIL, payload: e });
  }
};

export const CANCEL_PLAN_SUCCESS = `${MODULE_NAME}/CANCEL_PLAN/SUCCESS`;
export const CANCEL_PLAN_FAIL = `${MODULE_NAME}/CANCEL_PLAN/FAIL`;
export const cancelPlan = id => async (dispatch, getState) => {
  const { notes } = getFormValues(CANCELLATION_NOTES_FORM_NAME)(getState());
  try {
    const plan = await fetch(`/admin/api/plans/${id}/cancel`, {
      method: 'POST',
      body: { notes },
    });

    dispatch({
      type: CANCEL_PLAN_SUCCESS,
      payload: plan,
    });

    success('Plan was cancelled');

    return dispatch(getPlanDetails(id));
  } catch (e) {
    return dispatch({ type: CANCEL_PLAN_FAIL, payload: e });
  }
};

export const GET_CARS_DETAILS_SUCCESS = `${MODULE_NAME}/GET_CARS_DETAILS/SUCCESS`;
export const GET_CARS_DETAILS_FAIL = `${MODULE_NAME}/GET_CARS_DETAILS/FAIL`;

export const CHANGE_PLANS_TAB = `${MODULE_NAME}/CHANGE_PLANS_TAB`;
export const changePlansTab = tab => async dispatch => {
  const cancelled = tab === TABS.ALL ? null : true;

  dispatch(updateFilter('cancelled', cancelled));
  dispatch(changePlansPage(1));

  await dispatch(fetchPlans());

  dispatch({ type: CHANGE_PLANS_TAB, payload: tab });
};

export const UPDATE_CANCELLATION_NOTES_SUCCESS = `${MODULE_NAME}/UPDATE_CANCELLATION_NOTES/SUCCESS`;
export const UPDATE_CANCELLATION_NOTES_FAIL = `${MODULE_NAME}/UPDATE_CANCELLATION_NOTES/FAIL`;
export const updateCancellationNotes = () => async (dispatch, getState) => {
  const state = getState();
  const {
    admin: {
      planDetails: { id },
    },
  } = state;
  const { notes } = getFormValues(NOTE_DISPLAY_FORM_NAME)(state);

  try {
    await fetch(`/admin/api/plans/${id}/cancellation`, {
      method: 'PATCH',
      body: { notes },
    });

    return dispatch({
      type: UPDATE_CANCELLATION_NOTES_SUCCESS,
      payload: {
        notes,
      },
    });
  } catch (e) {
    return dispatch({
      type: UPDATE_CANCELLATION_NOTES_FAIL,
      payload: e,
    });
  }
};

export const UPDATE_CANCELLATION_META_SUCCESS = `${MODULE_NAME}/UPDATE_CANCELLATION_META/SUCCESS`;
export const UPDATE_CANCELLATION_META_FAIL = `${MODULE_NAME}/UPDATE_CANCELLATION_META/FAIL`;
export const updateCancellationMeta = (
  fieldName,
  enabled,
  planId,
) => async dispatch => {
  try {
    await fetch(`/admin/api/plans/${planId}/cancellation`, {
      method: 'PATCH',
      body: {
        [fieldName]: enabled,
      },
    });

    dispatch({
      type: UPDATE_CANCELLATION_META_SUCCESS,
      payload: {
        planId,
        [fieldName]: enabled,
      },
    });
    return dispatch(fetchPlans());
  } catch (e) {
    return dispatch({
      type: UPDATE_CANCELLATION_META_FAIL,
      payload: e,
    });
  }
};
